import type React from 'react';
import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { ROUTES } from '../routes';
import { useSession } from './session-context';

/** /welcome: a signed-in player goes to /. Showing it to anyone else marks them as a returning visitor. */
export const WelcomeGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { signedIn, markVisited } = useSession();

  useEffect(() => {
    if (!signedIn) {
      markVisited();
    }
  }, [signedIn, markVisited]);

  return signedIn ? <Navigate replace to={ROUTES.dashboard} /> : children;
};
